export default {"src":"/_next/static/media/wifi.79e7701f.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};